/*
 * Constants.
 */

export enum FormattingControlsEnum {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  STRIKE = 'strike',
  LIST = 'list',
  LINK = 'link',
  IMAGE = 'image',
  BLOCKQUOTE = 'blockquote',
  REMOVE = 'remove',
}

export const HtmlFormattingControls = [
  FormattingControlsEnum.BOLD,
  FormattingControlsEnum.ITALIC,
  FormattingControlsEnum.UNDERLINE,
  FormattingControlsEnum.STRIKE,
  FormattingControlsEnum.LIST,
  FormattingControlsEnum.LINK,
  FormattingControlsEnum.IMAGE,
  FormattingControlsEnum.BLOCKQUOTE,
  FormattingControlsEnum.REMOVE,
] as const;

export const MarkdownFormattingControls = [
  FormattingControlsEnum.BOLD,
  FormattingControlsEnum.ITALIC,
  FormattingControlsEnum.STRIKE,
  FormattingControlsEnum.LIST,
  FormattingControlsEnum.LINK,
  FormattingControlsEnum.BLOCKQUOTE,
] as const;
